<template>
  <div class="inline-block float-right">
    <div class="relative inline-block text-left">
      <div>
        <div class="flex">
          <a :href="record.url" target="_blank">
            <TButtonSvg label="Preview" color="white">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                />
              </svg>
            </TButtonSvg>
          </a>
          <router-link class="ml-2" :to="`${$route.fullPath}/edit`">
            <TButtonSvg label="Edit" color="white">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M4 20h4l10.5 -10.5a1.5 1.5 0 0 0 -4 -4l-10.5 10.5v4" />
                <line x1="13.5" y1="6.5" x2="17.5" y2="10.5" />
              </svg>
            </TButtonSvg>
          </router-link>
        </div>
      </div>
      <div class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg" v-if="showOptions">
        <div class="rounded-md bg-white shadow-xs text-indigo-600">
          <div class="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
            <a
              @click="handleAction('edit')"
              class="cursor-pointer block px-4 py-2 text-sm leading-5 hover:bg-gray-100 hover:text-indigo-600 focus:outline-none focus:bg-gray-100 focus:text-indigo-900"
              role="menuitem"
              >Edit job</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['record'],
  components: {},
  data() {
    return {
      showOptions: false,
      showContactUnsubscribe: false,
    };
  },
  methods: {
    handleAction(e) {
      this.showOptions = false;
    },
  },
};
</script>
